export enum EMoveArmDirection
{
  Unknown = 0,
  North = 1,
  South = 2,
  West = 3,
  East = 4,
  Up = 5,
  Down = 6,
  ClockWise = 7,
  CounterClockWise = 8,
  Center = 9,
}